import React from 'react';
import moment from 'moment';

import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { formatSegmentDay } from 'utils/date/format.util';
import { nowAsMoment } from 'utils/date/now.util';

const ComponentToPrint = React.forwardRef(({ procedures: proceduresFromProps, dateString, stylistList }, ref) => {
  const procedures = asArray(proceduresFromProps);

  const clientUserNames = procedures.reduce((array, item) => {
    const userName = item.appointment.client?.user_name ?? void 1;
    return userName && !array.includes(userName) ? [...array, userName] : array;
  }, []);

  const activeStylists = asArray(stylistList).filter((s) => 'active' === s?.status);

  const ifValidProceduresFor = (activeStylist) =>
    fromAnyToBool(
      procedures.filter(
        (p) => p?.stylist && p?.stylist?.user_name === activeStylist?.user_name && p?.appointment?.client,
      ).length,
    );

  // TODO: fix the warning in the console
  // ComponentToPrint.jsx:42 Deprecation warning: value provided is not in a recognized RFC2822 or ISO format.
  // moment construction falls back to js Date(), which is not reliable across all browsers and versions.
  // Non RFC2822/ISO date formats are discouraged.
  // Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.
  const displayDate =
    dateString === 'today' ? formatSegmentDay(nowAsMoment()) : moment(dateString).format('Do MMMM YYYY');

  return (
    <div data-bem="ComponentToPrint--scheduler" ref={ref}>
      {activeStylists.map(
        (activeStylist, index) =>
          ifValidProceduresFor(activeStylist) && (
            <div key={`${index}-${activeStylist?.id}`} data-bem="ComponentToPrint__header" className="tablePdfList">
              <div className="tablePdfHeader">
                <div className="stylistName">
                  Appointments for {activeStylist?.user_name}: {displayDate}
                </div>
              </div>

              {clientUserNames.map((singleClientName, index) => {
                const filteredProcedures = procedures
                  .filter((p) => p?.stylist?.user_name === activeStylist?.user_name)
                  .filter((p) => p?.appointment?.client?.user_name === singleClientName);

                if (!filteredProcedures.length) return null;

                return (
                  <div data-bem="ComponentToPrint__item" key={`${index}--${singleClientName}`}>
                    <h3 className="clientName">{singleClientName}</h3>

                    {filteredProcedures.map((p) => (
                      <div key={p?.id} className="pdf-appointment">
                        <div>
                          <div className="serviceName">
                            {moment(p?.start_time).format('hh:mm a')} - {p?.service?.name}
                          </div>
                          <div className="notes">
                            <span>Booking notes:</span>
                            <div> {p?.appointment?.notes}</div>
                          </div>
                          <div className="notes">
                            <span>Colour notes:</span>
                            <div>{p?.appointment?.client?.notes}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ),
      )}
    </div>
  );
});

export default ComponentToPrint;
